import React from 'react';
import FaIcon from '../../../Elements/FaIcon.js';

// The Commission Rates tabs (User page and Opportunity page) have no menu entry of their own, so the
// page-header guide link (userGuides.js) cannot reach their guide; this link opens it in a new tab.
const COMMISSION_RATES_GUIDE = 'docs/user-guides/commission-rates.html';

export default function CommissionRatesGuideLink() {
  return (
    <div className='text-end pb-1'>
      <a
        href={`${process.env.PUBLIC_URL}/${COMMISSION_RATES_GUIDE}`}
        target='_blank'
        rel='noopener noreferrer'
        title='Open the user guide for commission rates'
      >
        <FaIcon iconName='fa-regular fa-circle-question' /> Commission Rates user guide
      </a>
    </div>
  );
}
